var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("validation-provider", {
        attrs: {
          rules: _vm.requiredTelefones ? "hasTelefone" : "",
          name: _vm.nomeAba + "/Telefone(s)"
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var errors = ref.errors
              return [
                _c("el-table", {
                  attrs: { hidden: "hidden", data: _vm.telefones },
                  model: {
                    value: _vm.telefonesValidationValues,
                    callback: function($$v) {
                      _vm.telefonesValidationValues = $$v
                    },
                    expression: "telefonesValidationValues"
                  }
                })
              ]
            }
          }
        ])
      }),
      _c(
        "validation-provider",
        {
          attrs: {
            rules: _vm.requiredTelefones
              ? "hasTelefone:@" + _vm.nomeAba + "/Telefone(s)"
              : "",
            name: "$ignoreTelefone$"
          }
        },
        [
          _c("app-label", {
            attrs: { label: "Telefone(s):", required: _vm.requiredTelefones }
          }),
          _c(
            "el-input",
            {
              directives: [
                {
                  name: "mask",
                  rawName: "v-mask",
                  value: ["(##) #####-####", "(##) ####-####"],
                  expression: "['(##) #####-####', '(##) ####-####']"
                }
              ],
              staticClass: "input",
              class: { erro: _vm.errorsTelefone && _vm.errorsTelefone.length },
              attrs: { label: "Telefone", type: "tel" },
              model: {
                value: _vm.fone,
                callback: function($$v) {
                  _vm.fone = $$v
                },
                expression: "fone"
              }
            },
            [
              _c("el-button", {
                staticClass: "style",
                attrs: {
                  slot: "append",
                  icon: "el-icon-plus",
                  disabled: _vm.fone.length < 14
                },
                on: {
                  click: function($event) {
                    return _vm.addTelefone(_vm.fone)
                  }
                },
                slot: "append"
              })
            ],
            1
          ),
          _c("span", { staticClass: "help erro" }, [
            _vm._v(_vm._s(_vm.errorsTelefone ? _vm.errorsTelefone[0] : ""))
          ]),
          _c(
            "div",
            { staticClass: "tag-app-input marginTop" },
            _vm._l(_vm.telefones, function(telefone, index) {
              return _c(
                "el-tag",
                {
                  key: index,
                  attrs: { closable: "closable", type: "info", size: "medium" },
                  on: {
                    close: function($event) {
                      return _vm.removeTelefone(index)
                    }
                  }
                },
                [_vm._v(_vm._s(telefone))]
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13b566e3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13b566e3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppInputTelefone.vue
// module id = null
// module chunks = 